module.exports = __webpack_public_path__ + "static/media/delete-icon.0c966166.svg";